import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  myAccountPageTitle: 'حسابي | عقارماب',
  myAccount: 'حسابي',
  accountDetails: 'بيانات الحساب',
  companyInfo: 'بيانات الشركة',
  edit: 'تعديل',
  save: 'حفظ',
  unAvailable: 'غير متوفر',
  personalInfo: 'بيانات شخصية',
  privacy: 'الخصوصية والأمان',
  sequencePhoneNumber: 'رقم الهاتف يجب ان لا يكون رقم متشابه او ارقام متتاليه',
  invalidPhoneNumber: 'برجاء ادخال رقم هاتف صحيح',
  invalidPhoneMinLength: 'رقم الهاتف يجب ان يكون أكبر من 7 أرقام!',
  invalidPhonePattern: 'رقم الهاتف يجب ان لا يحتوي احرف مميزة أو مسافات!',
  invalidEmail: 'برجاء إدخال بريد الالكترونى صحيح',
  invalidName: 'برجاء ادخال اسم صحيح',
  requiredEmail: 'برجاء إدخال البريد الالكترونى',
  requiredPassword: 'برجاء إدخال كلمة المرور',
  requiredConfirmPassword: 'برجاء إدخال تاكيد كلمة المرور',
  passwordNotMatch: 'كلمة المرور غير مطابقة',
  minPassword: 'يجب ان تكون كلمة المرور 6 حروف او اكثر',
  requiredPhone: 'برجاء ادخال رقم هاتفك',
  selectValue: 'برجاء اختيار قيمة اولا',
  requiredNote: 'برجاء إدخال ملاحظة',
  accountImage: 'صورة الحساب',
  newPhoto: 'صورة جديدة',
  delete: 'حذف',
  companyLogo: 'شعار الشركة',
  fullName: 'الاسم بالكامل',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  currentPassword: 'كلمة المرور الحالية',
  changePassword: 'تغيير كلمة المرور',
  newPassword: 'كلمة المرور الجديدة',
  confirmPassword: 'تأكيد كلمة المرور',
  phoneNumber: 'رقم الهاتف',

  mainNumber: 'الرقم الرئيسي',
  otherNumber: 'الرقم الأخر',
  fullNamePlaceholder: 'ادخل اسمك',
  userType: 'نوع المستخدم',
  changeUserType: 'لتغيير نوع المستخدم برجاء الإتصال بمدير حسابك',
  companyDescription: 'وصف الشركة',
  companyDescriptionPlaceholder: 'اكتب وصف الشركة',
  maxCompanyDescription: '{{value}} حرف كحد أقصي',
  imageStillProcessing: 'الصورة قيد المراجعة',
  whatsappAvailable: 'يوجد واتساب على هذا الرقم',
  logoStillProcessing: 'شعار شركتكم قيد المراجعة.',
  failedChangeEmail:
    'لم نتمكن من تحديث البريد الإلكتروني الخاص بك. يرجى التأكد من المعلومات التي أدخلتها وإعادة المحاولة.',
  failedChangePassword:
    'لم نتمكن من تحديث كلمة المرور الخاصه بك. يرجى التأكد من المعلومات التي أدخلتها وإعادة المحاولة.',
  failedChangePhoneNumber:
    'لم نتمكن من تحديث رقم الهاتف الخاص بك. يرجى التأكد من المعلومات التي أدخلتها وإعادة المحاولة.',
  failedAddPhoneNumber:
    'لم نتمكن من اضافة رقم الهاتف الخاص بك. يرجى التأكد من المعلومات التي أدخلتها وإعادة المحاولة.',
  footerDescription:
    'خدمات عقارماب تساعدك على بيع وشراء العقارات بسهولة بالإضافة إلى تزويدك بمعلومات أساسية لإتخاذ واحد من أهم القرارات المالية في حياتك.',
  about: 'عن عقارماب',
  jobs: 'وظائف',
  contact: 'تواصل معنا',
  terms: 'الأحكام',
  search: 'ابحث',
  know: 'اعرف',
  list: 'اعلن',
  help: 'مساعدة؟ ',
  properties: 'عقارات',
  onlineExpos: 'Online Expos',
  mortgage: 'تمويل عقاري',
  valuation: 'تقييم عقاري',
  pricesGuide: 'أسعار العقارات',
  askNeighbors: 'إسأل أهل المنطقة',
  topAgents: 'الوسطاء المميزون',
  exhibitsGuide: 'دليل المعارض',
  realEstateIndex: 'المؤشر العقاري',
  adviceTips: 'نصائح عقارية',
  marketResearch: 'ابحاث ودراسات',
  knowMore: 'اعرف أكثر *',
  listYourProperty: 'اعلن عن عقارك',
  listCompanyProperties: 'اعلن عن عقارات شركتك',
  login: 'تسجيل الدخول',
  signUp: 'تسجيل حساب',
  activities: 'نشاطاتي',
  notes: 'ملاحظاتى',
  cancel: 'الغاء',
  loggedOutMenuCaption: 'اضف اعلانات ، ملاحظات ، المفضلات واكثر ... ',
  dashboard: 'لوحة التحكم',
  dashboardLabel: 'ادارة إعلاناتك, اتصالاتك, رصيدك والمزيد',
  dashboardAccessWarning:
    'لوحة التحكم مغلقة لانتهاء نقاطك. تحتاج إالى إعادة شحن باقتك لإدارة اعلاناتك، اتصالاتك، رصيدك، ومميزات اضافية',
  favorite: 'مفضلاتى',
  changeData: 'تعديل البيانات',
  discover: 'اكتشف',
  joinedSince: 'سجل منذ ',
  notifications: 'اشعاراتي',
  alerts: 'تنبيهاتي',
  listing: 'عقاراتي',
  credit: 'رصيدي',
  chargeCredit: 'اشحن رصيد',
  logout: 'تسجيل الخروج',
  ksa: 'السعودية',
  administration: 'إداره',
  compoundsRating: 'تقييم الكمبوندات',
  compounds: 'كمبوندات',
  localSwitcherText: 'English',
  manageContact: 'إدارة جهات اتصالك',
  manageContactDescription:
    'تحكم في أرقام الهاتف التي يراها المستخدمون علي اعلاناتك',
  manageContactNote:
    'يمكنك إضافة رقمين هاتفيين كحد أقصى لعرضهما علي إعلاناتك. لإضافة رقم هاتف جديد برجاء إزالة رقم آخر',
  advertisementNumbers: 'أرقام الاعلانات',
  new: 'جديد',
  number: '{{number}} رقم',
  add: 'أضف',
  addPhoneNumber: 'اضافة رقم هاتف ',
  showMoreNumbers: 'اظهر المزيد من الارقام',
  showLessNumbers: 'عرض أرقام أقل',
  errorTitle: 'عفواً..!',
  errorDescription: 'حدث خطأ فى الخادم ! من فضلك حاول مرة اخرى .',
  reload: 'إعادة تحميل الصفحة',
  ReportProblem: 'الإبلاغ عن مشكلة',
  notFoundTitle: 'عفواً..!',
  notFoundDescription: 'يبدو انه حدث خطأ ما! من فضلك حاول مرة اخرى',
  researchBtn: 'إعادة البحث',
  deleteNumber: 'هل انت متأكد من حذف الرقم',
  buyer: 'مشترى',
  privateOwner: 'مالك عقار',
  broker: 'مسوق عقاري',
  buildingDeveloper: 'مطور',
  compoundDeveloper: 'مطور كمبوند',
  checkPhoneNumber: 'التحقق من رقم الهاتف',
  send: 'إرسال',
  resendOTP: 'ارسل الرمز مره اخرى',
  savedCards: 'البطاقات المحفوظة',
  pay: 'ادفع',
  homePage: 'الصفحة الرئيسية',
  egp: 'جنيه',
  priceUnit: 'ج',
  card: 'بطاقة',
  subscriptionPlan: 'خطة الاشتراك',
  readMore: 'اقرأ أكثر',
  readLess: 'اقرأ أقل',
  paymentDetails: 'تفاصيل الدفع',
  okay: 'موافق',
  back: 'الرجوع',
  active: 'نشط',
  inActive: 'غير نشط',
  aqarmapPro: 'عقارماب برو',
  unlimitedServices: 'استمتع بمزايا غير محدودة',
  management: 'إدارة',
  mySubscription: 'اشتراكى',
  priceValue: '{{value}} <tag> ج.م</tag>',
  priceValuePerMonth: '{{value}} <tag> ج.م/ شهر</tag>',

  vatValue: 'ضريبه {{value}}',
  somethingWrong: 'حدث خطأ ما. الرجاء المحاولة مرة أخرى',
  addMobileInstruction: 'لتغيير رقم الهاتف او البريد الإلكتروني، يجب',
  setPassword: 'تعيين كلمة المرور',
  checkout: ' الدفع',
  discoverMore: 'اكتشف المزيد',
  callForPrice: 'اتصل لمعرفة السعر',
  startingFrom: 'يبدأ من',
  poweredByAI: 'مُدعم بالذكاء الاصطناعي',
  pricePerMeter: 'سعر المتر',
  wallet: 'المحفظة',
  useWalletBalance: 'استخدام رصيد المحفظة',
  cashPayment: 'الدفع النقدي',
  cashSubscriptionDescription: 'تواصل معانا لاتمام عملية الدفع',
  to: ' إلى ',
  saudiBannerText: 'الآن تملّك العقارات للأجانب في السعودية',
  theBalance: 'الرصيد',
  language: 'اللغة',
  country: 'البلد',
  valuationDescription: 'قيم سعر أي عقار بسهولة وسرعة',
  pricesGuideDescription: 'اعرف سعر المتر في المناطق المختلفة',
  askNeighborsDescription: 'احصل على إجابات دقيقة من سكان المنطقة',
  topAgentsDescription: 'تواصل مع أفضل الوسطاء العقاريين',
  exhibitsGuideDescription: 'اكتشف كل المعارض العقاريه القادمة',
  realEstateIndexDescription: 'تعرف على مستوى الطلب ووضع السوق ',
  adviceTipsDescription: 'تصفح معلومات ونصائح قيمة وعملية',
  marketResearchDescription: 'احصل علي معلومات و ابحاث مباشره من المشتريين',
  knowMoreDescription: 'تصفح معلومات ونصائح قيمة وعملية ',
  forSale: 'للبيع',
  forRent: 'للإيجار',
  compoundsRatingDescription: 'اكتشف تقييم الكمبوند و المطور و رأي الخبراء',
  basicInformation: 'البيانات الاساسية',
  educationAndProfession: 'البيانات التعليمية والمهنية',
  purchasePurpose: 'الهدف من الشراء',
  purchaseFinancing: 'طريقة الدفع',
  purchasePreferences: 'تفضيلات الشراء',
  purchaseTimeframe: 'موعد الشراء',
  copyText: 'نسخ الرابط',
  copyTextSuccess: 'تم نسخ الرابط',
  facebook: 'فيسبوك',
  twitter: 'تويتر',
  shareDescription: 'بمجرد مشاركة العقار، سيتمكن الجميع من رؤيتها',
  removeFromFavorites: 'إزالة من المُفضلة',
  remainingInstallmentPeriod: 'مدة التقسيط المتبقية',
  forgetPassword: 'نسيت كلمة السر؟',
  regionModalTitle: 'تغيير اللغة',
  footerMap: 'خريطة الموقع',
  footerResearch: 'أبحاث',
  footerImportantLinks: 'روابط مهمة',
  footerContactBy: 'تواصل معنا عبر',
  whatsapp: 'واتساب',
  appStore: 'متجر التطبيقات',
  googlePlay: 'جوجل بلاي',
  downloadApp: 'حمل التطبيق',
  showMore: 'أظهر المزيد',
  showLess: 'اظهر أقل',
  newLaunch: 'طرح جديد',
  done: 'تم',
  change: 'تغيير',
  termsAndConditions: 'بالاشتراك فإنك توافق على <tag>الشروط والأحكام</tag>',
  aqarmapPackages: 'باقات عقارماب',
  packagesBenefits: 'استفد من مزايا حصرية للبيع أو الشراء',
  pointsHistory: 'سجل النقاط',
});
